import classes from "./form-elements.module.css";

interface DropdownMenuItemProps {
    isActive: boolean;
    isSelected: boolean;
    children: React.ReactNode;
    index: number;
    item: any;
}

export const DropdownMenuItem = ({
    isActive,
    isSelected,
    children,
}: DropdownMenuItemProps) => (
    <li
        className={
            `${classes.dropdownMenuItem}` +
            `${isActive ? ` ${classes.isActive}` : ""}` +
            `${isSelected ? ` ${classes.isSelected}` : ""}`
        }
    >
        {children}
    </li>
);
